import type { FormItem } from 'form/types';

const step: FormItem[] = [
  {
    type: 'checkbox',
    id: 'site-limit',
    label: 'My site will have no more than five people, plus a supervisor'
  },
  {
    type: 'checkbox',
    id: 'covid-marshal',
    label:
      'I understand my COVID Marshal may be a site supervisor performing the role across multiple sites'
  },
  {
    type: 'checkbox',
    id: 'vaccinated-movement',
    label:
      'Any workers who are moving between metropolitan Melbourne and regional Victoria are fully vaccinated'
  }
];

export default step;
